import { baseAxios } from './Axios';
//Components
import { Parameters } from '../components/Parameters';
import { TemplateTriviaQuestions } from '../components/Templates';
import { CalcTime } from '../components/CalcTime';
import { ResumeAnswers } from '../components/ResumeAnswers';
import { DataParcial } from '../components/DataParcial';
import { soundTrivia, SoundStop, SoundStadium } from '../components/Sounds';
//Api
import { SaveQuestion, saveAllQuestions } from './SaveQuestion';
import { SetWinner } from './SetWinner';

const Trivia = (()=>{
    
    const requestCheckTime = async()=>{
        const response = await baseAxios.get('/check-time')
        return response.data;
    }

    //Dependencies
    const _TriviaDependencies = ()=>{
        Parameters();
        ResumeAnswers();
        DataParcial();
        SoundStop();
    }
    //Request for get questions
    const requestQuestions = async ()=>{
        const categorie = localStorage.getItem('categorie');
        const response = await baseAxios.get(`/get-questions?category=${categorie ? categorie : 'Aficionado'}`);
        return response.data;
    }
    //Config
    const _TriviaConfig = ()=>{
        const time = document.querySelector('#time-to-start');
        const triviaState = document.querySelector('.trivia-state');
        const triviaQuestions = document.querySelector('#trivia-questions');
        const triviaTime = document.querySelector('#dinamic-time-trivia');
        const triviaTimeResume = document.querySelector('#dinamic-time-trivia-resume');
        const triviaIframe = document.querySelector('#iframe-trivia-game');
        const triviaIframeSound = document.querySelector('#sound-video-iframe');
        const loader = document.querySelector('.loader');
        const categorieLocal = localStorage.getItem('categorie');
        const currentURL = window.location.href;
        const searchParams = new URLSearchParams(currentURL);

        //Create iframe player
        const player = new Vimeo.Player(triviaIframe);

        const renderQuestionsFlux = ()=>{
            //Render questions
            const ctn = document.querySelector('#render-questions');
            const questions = JSON.parse(localStorage.getItem('questions'));
            //Render questions
            questions.forEach((question, indice)=>{
                const { id, pregunta, respuesta1, respuesta2, respuesta3, respuesta4, state } =  question;
                state == undefined && (question.state = true);
                questions.state = true;
                if(question.state){
                    const template = TemplateTriviaQuestions(indice, id, pregunta, respuesta1, respuesta2, respuesta3, respuesta4);
                    ctn.append(template);
                }
            });
            //Enable ux && ui for question
            CalcTime();
            SaveQuestion();
            soundTrivia();
        }

        //Request
        requestQuestions().then((res)=>{
            const { error, left_time_to_start } = res;
            if(error){
                time.textContent = left_time_to_start;
                triviaState.classList.add('soon');
                //Loop request if exist error
                setInterval(()=>{
                    requestQuestions().then((res)=>{
                        const { left_time_to_start, seconds_to_start, error } = res;
                        time.textContent = left_time_to_start;
                        //Show loader for transition items
                        seconds_to_start == 3 && loader.classList.remove('disabled');
                        seconds_to_start == 1 && (
                            time.closest('section').classList.add('hidden'), 
                            triviaQuestions.classList.remove('hidden')
                        );
                        //Save quiestions in local storage
                        if(!error){
                            triviaState.classList.remove('soon');
                            localStorage.setItem('questions', JSON.stringify(res));
                            location.reload();
                        }
                        //Remove o play audio
                        error && SoundStadium();
                    });
                }, 1000);
            }else{
                //Save quiestions in local storage and hidden y show items
                !localStorage.getItem('questions') && localStorage.setItem('questions', JSON.stringify(res));
                triviaState.classList.remove('soon');
                time.closest('section').classList.add('hidden');
                triviaQuestions.classList.remove('hidden');
                renderQuestionsFlux();
            }
        }).catch(err=>{
            console.log('ha ocurrido un error inesperado' + err);
        });
        //Check time
        setInterval(()=>{
            requestCheckTime()
                .then((res)=>{
                    const { seconds_to_start, time_to_end, error, too_late } = res;
                    const triviaResume = document.querySelector('#trivia-resume').classList.contains('hidden');
                    //activate another video when there are 30 seconds left to start
                    if(seconds_to_start < 35 && 35 > 0 && !triviaIframe.classList.contains('iframe-video-ball')){
                        triviaIframe && triviaIframe.classList.add('iframe-video-ball');
                        triviaIframe && triviaIframe.classList.remove('hidden');
                        player.setCurrentTime(0);
                        time.closest('.trivia-time') && (time.closest('.trivia-time').classList.add('hidden-picture'));
                    }
                     if(seconds_to_start < 35 && 35 > 0){
                        if(!document.querySelector('.stop-audio')){
                            triviaIframeSound && triviaIframeSound.play();
                        }
                        document.querySelector('#stop-sound')?.classList.add('light');
                        document.querySelector('#sound-stadium').pause();
                        document.querySelector('#coming-soon-trivia')?.classList.add('light');
                     }
                    //Save questions when end time
                    if(time_to_end == "00:00:02" && triviaResume){
                        triviaState.classList.add('soon');
                        saveAllQuestions();
                        localStorage.removeItem('winner-validate');
                    }
                    //Change message
                    if(error && !triviaResume){
                        document.querySelector('#coming-soon-trivia')?.classList.add('resume');
                        document.querySelector('#coming-soon-trivia p').textContent = 'Generando resultados';
                    }
                    //Remove answers
                    if(error && !triviaResume){
                        triviaState.classList.add('soon');
                        localStorage.removeItem('answers');
                        localStorage.removeItem('winner-validate')
                    }
                    if(error && !localStorage.getItem('winner-validate')){
                        setTimeout(()=>{
                            SetWinner();
                        },2000);
                    }
                    //Time trivia
                    if(time_to_end){
                        triviaTime.textContent =  `Tienes ${time_to_end} para responder todas las preguntas`;
                        triviaTimeResume.textContent =  `¡Ey, crack! Estamos generando tus resultados ${time_to_end}`;
                    }else{
                        triviaTimeResume.textContent =  `¡Ey, crack! No te despegues de la pantalla, estamos calentando los motores para ver si te llevas uno de nuestros premios`;
                    }
                    //Remove questions
                    error && localStorage.removeItem('questions');
                    error && localStorage.removeItem('categorie-enable');
                    //Validate url
                    searchParams.forEach(function(value) {
                        if(categorieLocal == value && !error){
                            value == 'Aficionado' && localStorage.setItem('categorie-enable', 0);
                            value == 'Profesional' && localStorage.setItem('categorie-enable', 1);
                            value == 'Legendario' && localStorage.setItem('categorie-enable', 2);
                        }else{
                            !error && (window.location.href = '/jugar');
                        }
                    });
                }).catch(err=>{
                    console.log(err);
                });
            },800); 
    }

    /*
    *Return child functions in a objects
    */
    return{
        setHandleEvent: function(){
            try { 
                _TriviaDependencies(); 
            } catch (error) { 
                console.log(error);
                localStorage.clear(); 
                location.href = "/jugar";
            }
            try { 
                _TriviaConfig(); 
            } catch (error) { 
                console.log(error); 
                localStorage.clear(); 
                location.href = "/jugar";
            }
        }
    }
})();

/*
*Load global functions
*/
const loadTriviaHandlers = ()=>{
    Trivia.setHandleEvent();
}

export { loadTriviaHandlers }